import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

import { CheckboxAllOption } from '@/interfaces/CheckboxAllOptions';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCheckboxAll',
  props: /*#__PURE__*/_mergeModels({
    name: {}
  }, {
    "options": { required: true },
    "optionsModifiers": {},
  }),
  emits: ["update:options"],
  setup(__props: any) {

    

    const options = _useModel<CheckboxAllOption<Record<string, unknown>>[]>(__props, 'options');

return (_ctx: any,_cache: any) => {
  const _component_checkbox_all = _resolveComponent("checkbox-all")!
  const _component_base_checkbox = _resolveComponent("base-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_checkbox_all, {
      name: _ctx.name,
      list: options.value,
      onSelect: _cache[0] || (_cache[0] = (listUpdated) => (options.value = listUpdated)),
      onUnselect: _cache[1] || (_cache[1] = (listUpdated) => (options.value = listUpdated))
    }, null, 8, ["name", "list"]),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, index) => {
        return (_openBlock(), _createBlock(_component_base_checkbox, {
          key: index,
          id: index,
          name: option.value + index,
          checked: option.checked,
          "onUpdate:checked": ($event: any) => ((option.checked) = $event),
          label: option.text,
          "sub-label": option.subLabel,
          disabled: option.disabled
        }, null, 8, ["id", "name", "checked", "onUpdate:checked", "label", "sub-label", "disabled"]))
      }), 128))
    ])
  ], 64))
}
}

})